import React from 'react';
import PropTypes from 'prop-types';
import { FORM_IDS, formDefaultValues } from 'providers/LoginProvider';
import {
  PasswordField,
  UsernameField,
} from '../shared/StyledComponents';

export default function UsernamePassword({
  loginBag,
  handleLogin,
}) {
  const { getError, handleBlur, handleChange, validationRef, setDirty } = loginBag;

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
      setDirty((prevDirty) => ({
        ...prevDirty,
        [FORM_IDS.PASSWORD]: true,
      }));
    }
  };

  return (
    <>
      <UsernameField
        autoComplete="username"
        label="Username"
        placeholder="Username or Email Address"
        id={FORM_IDS.USERNAME}
        error={getError(FORM_IDS.USERNAME)}
        onBlur={handleBlur(FORM_IDS.USERNAME)}
        onChange={handleChange(FORM_IDS.USERNAME)}
        validationRef={validationRef}
        maxLength={50}
        defaultValue={formDefaultValues.username}
        required
      />
      <PasswordField
        autoComplete="password"
        error={getError(FORM_IDS.PASSWORD)}
        id={FORM_IDS.PASSWORD}
        label="Password"
        maxLength={50}
        onBlur={handleBlur(FORM_IDS.PASSWORD)}
        onChange={handleChange(FORM_IDS.PASSWORD)}
        defaultValue={formDefaultValues.password}
        placeholder="Access Code/Password"
        required
        validationRef={validationRef}
        inputProps={{ onKeyDown: handleKeyDown }}
      />
    </>
  );
}

UsernamePassword.propTypes = {
  loginBag: PropTypes.object.isRequired,
  handleLogin: PropTypes.func.isRequired,
};
